<template>
    <div style="margin-top: 10px;">
        <div :class="messageType == 1 ? 'error' : messageType == 2 ? 'warning' : messageType == 0 ? 'info' : 'normal'" style="text-align: center;">
            {{ message }}
        </div>
    </div>
</template>
<script>
export default {
    name: "MessageComponent",
    props: ["message", "messageType"]
}
</script>
<style scoped>
.error {
    color: red;
    font-weight: bold;
    font-style: italic;
}

.info {
    color: green;
}

.warning {
    color: orange;
    font-weight: bold;
    font-style: italic;
}

.normal {
    color: black;
}</style>